import {Component, HostBinding, Input} from '@angular/core';
import {UiIconEnum} from './ui-icon.enum';

@Component({
    template: ``,
    selector: 'ui-icon',
    standalone: false
})
export class UiIconComponent {
    @Input() icon: keyof typeof UiIconEnum;

    @HostBinding('class') get className() {
        const classes = [
            'ui-icons',
            this.icon.toLowerCase() + '-icon',
        ];
        return classes.filter(Boolean).join(' ');
    }

}
